const sortbyInit = (sortElement: HTMLElement) => {
  const applyFilter = sortElement.querySelector('.apply-filters') as HTMLButtonElement;
  const filterItems = sortElement.querySelectorAll('.filter-items') as NodeListOf<HTMLElement>;

  filterItems.forEach((filterItem) => {
    filterItem.addEventListener('click', () => {
      // Set a timeout of 300 milliseconds and apply a click on applyFilter variable
      setTimeout(() => {
        applyFilter.click();
      }, 300);
    });
  });
};

export default sortbyInit;
